<h1>要員選択画面</h1>
<mat-card>
  <mat-card-content>要員を選択してください。</mat-card-content>
  <mat-radio-group [(ngModel)]="selectedUserId">
    <table style="width: 100%; border-collapse: collapse;">
      <thead>
        <tr>
          <th style="width: 3%;"></th>
          <th style="width: 10%;">要員コード</th>
          <th style="width: 29%;">会社名</th>
          <th style="width: 29%;">組織名</th>
          <th style="width: 29%;">ユーザ名</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of users">
          <td style="width: 3%; text-align: center;">
            <mat-radio-button [value]="user.id" style="margin-left: 6px;"></mat-radio-button>
          </td>
          <td style="width: 10%;">{{ user.id }}</td>
          <td style="width: 29%;">{{ user.companyName }}</td>
          <td style="width: 29%;">{{ user.organizationName }}</td>
          <td style="width: 29%;">{{ user.userName }}</td>
        </tr>
      </tbody>
    </table>
  </mat-radio-group>

  <div fxLayout="row" fxLayoutAlign="end center" class="div-button-ok">
    <button [disabled]="!selectedUserId" color="primary" mat-raised-button cdkFocusInitial
      (click)="selectUser()">OK</button>
  </div>

</mat-card>